import styled from 'styled-components';
import { color } from '../../../../atoms/colors';
import { font } from '../../../../atoms/typography';
import { shadow } from '../../../../atoms/shadows';
import { atMinWidth } from '../../../../atoms/breakpoints';
import { spacing } from '../../../../atoms/spacing';
import {
  defaultStyles,
  variants,
  sizes,
} from '../../../CallToAction/styles/CallToAction.styled';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${color.midnight[25]};
  ${shadow('xl', 'dark')};
  border-radius: ${spacing[16]};
  gap: ${spacing[16]};
  padding: ${spacing[32]} ${spacing[16]};
  border-top: 7px solid ${color.blue[700]};
  ${atMinWidth.sm`
    padding: ${spacing[32]} ${spacing[40]};
  `}
  &.loading {
    height: 100%;
    align-items: center;
    justify-content: center;
  }
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[8]};
  && input {
    margin-bottom: ${spacing[12]};
  }
`;
export const Heading = styled.h3`
  width: 100%;
  text-align: center;
  ${font('display', 'sm', '500')}
  color: ${color.darkBlue[1000]};
`;
export const Subhead = styled.p`
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #515667;
  margin-bottom: 24px;
`;
export const Button = styled.button`
  width: 100%;
  text-align: center;
  margin-top: ${spacing[12]};
  transition: all 250ms ease-in-out;
  ${defaultStyles}
  ${sizes.sm}
  ${variants['Filled - Blue']}
  ${atMinWidth.md`
      ${sizes.md}
  `}
   ${atMinWidth.xl`
      ${sizes.lg}
  `}
`;
